let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("etDR2")).then(() => parcelRequire('lAzw2'));